import React from "react";
import { useI18n } from "../../i18n";

export const Marquee = () => {
  const { t } = useI18n();
  const text = t.marquee;
  return (
    <section
      data-testid="marquee"
      className="relative py-12 md:py-16 overflow-hidden bg-[#030712]"
    >
      {/* Top fade — soft dissolve from Hero into the marquee band */}
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#030712] to-transparent pointer-events-none" />
      {/* Bottom fade — soft dissolve into the next section */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#030712] to-transparent pointer-events-none" />
      {/* Ultra-thin center divider guides (no hard borders) */}
      <div className="absolute inset-x-0 top-6 h-px bg-gradient-to-r from-transparent via-white/8 to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-6 h-px bg-gradient-to-r from-transparent via-white/8 to-transparent pointer-events-none" />

      <div className="relative animate-marquee font-mono-tech text-sm md:text-base tracking-[0.15em] text-gray-400">
        {[0, 1].map((k) => (
          <span key={k} className="mx-0">
            {text}{text}
          </span>
        ))}
      </div>
    </section>
  );
};
